module.exports = __webpack_public_path__ + "img/fifa21.1b84caa4.png";